import { ClauseTags } from '../../clause-library/store';
import { DropdownOption } from '../dropdown/Dropdown';
import styles from './ClauseModal.module.scss';

const { agreementBackground, jurisdictionBackground, counterpartyBackground, productBackground, provisionBackground, miscellaneousBackground, opinionsBackground } = styles;

const { agreementBackgroundSelected, jurisdictionBackgroundSelected, counterpartyBackgroundSelected, productBackgroundSelected, provisionBackgroundSelected, miscellaneousBackgroundSelected, opinionsBackgroundSelected } = styles;

export const getUnselectedTagBackgroundColour = (value: keyof ClauseTags) => {
    switch (value) {
        case 'agreementType':
            return agreementBackgroundSelected;
        case 'jurisdiction':
            return jurisdictionBackgroundSelected;
        case 'counterpartyType':
            return counterpartyBackgroundSelected;
        case 'productType':
            return productBackgroundSelected;
        case 'provisionType':
            return provisionBackgroundSelected;
        case 'opinions':
            return opinionsBackgroundSelected;
        case 'miscellaneous':
        default:
            return miscellaneousBackgroundSelected;
    }
};

export const getTagTypeLabel = (value: keyof ClauseTags) => {
    switch (value) {
        case 'agreementType':
            return 'Agreement Type';
        case 'jurisdiction':
            return 'Jurisdiction';
        case 'counterpartyType':
            return 'Counterparty Type';
        case 'productType':
            return 'Product Type';
        case 'provisionType':
            return 'Provision Type';
        case 'opinions':
            return 'Opinions';
        case 'miscellaneous':
        default:
            return 'Miscellaneous';
    }
};

export const tagCategoryOptions: DropdownOption[] = [
    { value: 'agreementType', label: 'Agreement Type' },
    { value: 'jurisdiction', label: 'Jurisdiction' },
    { value: 'counterpartyType', label: 'Counterparty Type' },
    { value: 'productType', label: 'Product Type' },
    { value: 'provisionType', label: 'Provision Type' },
    { value: 'miscellaneous', label: 'Miscellaneous' },
    { value: 'opinions', label: 'Opinions' }
];

export const getTagBackgroundColour = (value: keyof ClauseTags) => {
    switch (value) {
        case 'agreementType':
            return agreementBackground;
        case 'jurisdiction':
            return jurisdictionBackground;
        case 'counterpartyType':
            return counterpartyBackground;
        case 'productType':
            return productBackground;
        case 'provisionType':
            return provisionBackground;
        case 'opinions':
            return opinionsBackground;
        case 'miscellaneous':
        default:
            return miscellaneousBackground;
    }
};
